/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('.blog-section .inline-nav li a');
    console.log(links);

    links.forEach((a, i) => {
      const num = (i % 5) + 1; // cycles 1–5 repeatedly
      a.classList.add(`item-${num}`);
    });
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', function(event) {
    // Use event delegation: check if the clicked element is a slider-dot
    const clickedDot = event.target.closest('[data-ele="slider-dot"]');

    // If it's not a dot or not inside a stacked container, do nothing
    if (!clickedDot || !clickedDot.closest('[data-ele="stacked"]')) return;

    try {
        const blockId = clickedDot.getAttribute('data-slider-dot');
        const parentContainer = clickedDot.closest('[data-ele="stacked"]');

        if (!blockId || !parentContainer) {
            console.warn('Missing block ID or parent container.');
            return;
        }

        // Remove 'active-dot' from all slider dots
        const allDots = parentContainer.querySelectorAll('[data-ele="slider-dot"]');
        allDots.forEach(dot => dot.classList.remove('active-dot'));

        // Add 'active-dot' to the clicked dot
        clickedDot.classList.add('active-dot');

        // Remove 'active-slide' from all slides
        const allSlides = parentContainer.querySelectorAll('[data-ele="slider-slide"]');
        allSlides.forEach(slide => slide.classList.remove('active-slide'));

        // Add 'active-slide' to the corresponding slide
        const targetSlide = parentContainer.querySelector('[data-ele="slider-slide"][data-slide="' + blockId + '"]');

        if (targetSlide) {
            targetSlide.classList.add('active-slide');
        } else {
            console.warn(`Slide with data-slide="${blockId}" not found`);
        }

    } catch (error) {
        console.error('Slider dot click error:', error);
    }
});



document.addEventListener('theme:cart:add', function (e) {
  const button = e.detail.button;
  const formWrapper = button.closest('.form__wrapper');
  if (!formWrapper) return;

  const form = button.closest('form');
  if (!form) return;

  const selects = formWrapper.querySelectorAll('select[name^="properties["]');
  const customTextInput = formWrapper.querySelector('input[name="properties[Front Custom Text]"]');

  let allValid = true;

  // 🧩 Resync hidden inputs before validation
  selects.forEach((select) => syncHiddenInput(select, form));

  // 🧩 Validate dropdown selects
  selects.forEach((select) => {
    const selectedValue = select.value.trim();
    const existingError = select.parentElement.querySelector('.letter-error');
    if (existingError) existingError.remove();

    const firstOptionText = select.options[0]?.textContent.trim() || '';
    const isLetterSelect = /Letter/i.test(firstOptionText);
    const isNumberSelect = /Number/i.test(firstOptionText);

    if (/^Choose/i.test(selectedValue) || selectedValue === '') {
      allValid = false;
      const message = isLetterSelect
        ? 'Select a letter before adding to cart.'
        : isNumberSelect
        ? 'Select a number before adding to cart.'
        : 'Please make a selection before adding to cart.';
      showSelectError(select, message);
    } else {
      select.classList.remove('has-error');
    }

    // 🧩 Attach listener to clear error + resync on change
    if (!select.dataset.errorListenerAttached) {
      select.addEventListener('change', () => {
        const err = select.parentElement.querySelector('.letter-error');
        if (err) err.remove();
        select.classList.remove('has-error');
        syncHiddenInput(select, form);
      });
      select.dataset.errorListenerAttached = 'true';
    }
  });

  // 🧩 Validate & sync Front Custom Text
  if (customTextInput) {
    const value = customTextInput.value.trim();
    const min = parseInt(customTextInput.getAttribute('minlength')) || 3;
    const max = parseInt(customTextInput.getAttribute('maxlength')) || 8;

    const existingError = customTextInput.parentElement.querySelector('.letter-error');
    if (existingError) existingError.remove();

    if (value === '' || value.length < min || value.length > max) {
      allValid = false;
      const message = `Please enter ${min}-${max} characters before adding to cart.`;
      showSelectError(customTextInput, message);
    } else {
      customTextInput.classList.remove('has-error');
      syncHiddenInput(customTextInput, form); // ✅ Sync hidden input just like dropdowns
    }

    // 🧩 Clear error + resync hidden input on input
    if (!customTextInput.dataset.errorListenerAttached) {
      customTextInput.addEventListener('input', () => {
        const err = customTextInput.parentElement.querySelector('.letter-error');
        if (err) err.remove();
        customTextInput.classList.remove('has-error');
        //syncHiddenInput(customTextInput, form);
      });
      customTextInput.dataset.errorListenerAttached = 'true';
    }
    syncHiddenInput(customTextInput, form);
  }

  if (!allValid) {
    console.warn('Validation failed: missing or invalid inputs.');
    e.stopImmediatePropagation();
    e.preventDefault();
    return;
  }

  // ✅ If validation passes, dispatch validated event
  document.dispatchEvent(
    new CustomEvent('theme:cart:add:validated', { detail: e.detail })
  );
});

// 🔹 Live sync Front Custom Text input into hidden field
document.addEventListener('DOMContentLoaded', () => {
  const formWrappers = document.querySelectorAll('.product__wrapper');

  formWrappers.forEach((wrapper) => {
    const form = wrapper.querySelector('product-form form');
    if (!form) return;

    const customTextInput = wrapper.querySelector('input[name="properties[Front Custom Text]"]');
    if (customTextInput){
      // Initial sync (in case of prefilled input)
      syncHiddenInput(customTextInput, form);

      // Live update on typing
      customTextInput.addEventListener('input', () => {
        syncHiddenInput(customTextInput, form);
      });  
    }

    


    // ✅ Attach event delegation *within this wrapper's context*
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.ptc_button');
      if (!btn) return;
      
      // Gather all inputs/selects inside the wrapper
      const fields = wrapper.querySelectorAll(
        'input[name^="properties["], select[name^="properties["]'
      );
      console.log(fields);
      // Observe DOM for modal appearing
      const observer = new MutationObserver(() => {
        const modal = document.querySelector('.pplr_crop-modal');
        if (modal && modal.querySelector('form')) {
          const modalForm = modal.querySelector('form');
          console.log('modalForm', modalForm);
          fields.forEach((field) => {
            // console.log('fields', field);
            // const modalField = modalForm.querySelector(
            //   `[name="${CSS.escape(field.name)}"]`
            // );
            //if (modalField) {
              syncHiddenInput(field, modalForm); // sync current value
            //}
          });

          observer.disconnect(); // stop observing after syncing
        }else{
          console.log('modal Not Found');
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    });


  });


      



});


// 🔧 Shared helper functions
function showSelectError(input, message) {
  input.classList.add('has-error');
  const error = document.createElement('div');
  error.className = 'letter-error';
  error.style.color = 'red';
  error.style.fontSize = '13px';
  error.style.marginTop = '4px';
  error.textContent = message;
  input.parentElement.appendChild(error);
}

function syncHiddenInput(input, form) {
  const name = input.getAttribute('name');
  // Don't copy if input is disabled
  if (input.disabled) return;

  const value = input.value.trim();
  const existing = form.querySelector(
    `input[type="hidden"][name="${CSS.escape(name)}"]`
  );

  // Remove hidden input if no valid value
  if (/^Choose/i.test(value) || value === '') {
    if (existing) existing.remove();
    return;
  }

  // Update or create hidden input
  if (existing) {
    existing.value = value;
  } else {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = name;
    hidden.value = value;
    //form.appendChild(hidden);
    //form.prepend(hidden);
    // Check if name is specifically "properties[Shipping Estimation]"
    if (name == 'properties[Shipping Estimation]') {
        // Add to the end of the form
        form.appendChild(hidden);
    } else {
        // Add to the beginning of the form
        form.prepend(hidden);
    }
  }
}

